import React, { useEffect, useRef } from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';

const SystemBanner = ({ message, show = true, onDismiss }) => {
  const bannerRef = useRef(null);
  const navigate = useNavigate();
  
  const handleDeliverabilityClick = (e) => {
    e.preventDefault();
    navigate('/settings', { state: { navigateToDeliverability: true } });
  };
  
  useEffect(() => {
    if (bannerRef.current && show) {
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty('--banner-height', `${height}px`);
    } else {
      document.documentElement.style.setProperty('--banner-height', '0px');
    }
  }, [show, message]);
  
  if (!show) return null;

  return (
    <Box
      ref={bannerRef}
      sx={{
        backgroundColor: '#FDC95D',
        color: 'black',
        padding: { xs: '8px 16px', sm: '12px 24px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        width: '100%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1500,
        flexWrap: 'nowrap'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, flex: 1 }}>
        <NotificationsIcon sx={{ fontSize: 20 }} />
        <Typography 
          variant="body2" 
          component="span"
          sx={{ 
            fontWeight: 500,
            display: 'inline',
            lineHeight: 1.4,
            fontSize: { xs: '0.8rem', sm: '0.875rem' },
            textAlign: 'center'
          }}
        >
          To ensure deliverability of content we have recently updated our allowlisting requirements to include multiple IP addresses. Please refer to the{' '}
          <Link
            component="button"
            onClick={handleDeliverabilityClick}
            sx={{
              color: 'secondary.main',
              textDecoration: 'underline',
              fontWeight: 600,
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              '&:hover': {
                color: 'secondary.dark',
                textDecoration: 'none'
              }
            }}
          >
            deliverability information
          </Link>
          {' '}for details.
        </Typography>
      </Box>
      {onDismiss && (
        <IconButton
          onClick={onDismiss}
          size="small"
          sx={{
            color: 'black',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default SystemBanner;